import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentLanguage: localStorage.getItem('language') || 'tr',
  availableLanguages: [
    { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
    { code: 'en', name: 'English', flag: '🇺🇸' }
  ]
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    changeLanguage: (state, action) => {
      state.currentLanguage = action.payload;
      localStorage.setItem('language', action.payload);
    },
    setLanguage: (state, action) => {
      state.currentLanguage = action.payload;
    }
  }
});

export const { changeLanguage, setLanguage } = languageSlice.actions;
export default languageSlice.reducer; 